import React from 'react';
// styles
import styled from 'styled-components';

const NonPalletizedModalIcon = ({ className, ...props }) => (
  <svg
    role="img"
    aria-label="Non Palletized Info"
    {...props}
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#F2F5F8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.1024 16.8H41.8597V27.0077V28.7345V37.2397H44V41.0454H39.1319V43.3298H33.863V41.0454H30.8605H29.1395H25.8753V43.3298H20.6064V41.0454H16V37.2397H18.14V28.7345V27.0077V16.8H31.8335H38.1024ZM36.398 18.5045H33.5379V19.8398H36.398V18.5045ZM31.8335 18.5045V21.5442H38.1024V18.5045H40.1553V27.0077H19.8444V18.5045H31.8335ZM40.1553 28.7345H19.8444V37.2377H40.1553V28.7345ZM22.3108 41.6254V41.29H24.1709V41.6254H22.3108ZM35.5674 41.29V41.6254H37.4275V41.29H35.5674Z"
      fill="#94A6B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.3182 6.86219C15.539 7.79163 5.93278 18.9047 6.86222 31.684C7.79166 44.4632 18.9047 54.0694 31.684 53.14C44.4633 52.2105 54.0694 41.0974 53.14 28.3182C52.8486 24.3114 51.5569 20.6183 49.527 17.4634L47.9193 18.7815L47 13L52.4225 15.0896L50.9276 16.3152C53.1809 19.7541 54.616 23.798 54.9352 28.1876C55.9368 41.9584 45.5853 53.9337 31.8146 54.9352C18.0438 55.9368 6.06851 45.5853 5.06696 31.8145C4.06542 18.0438 14.4169 6.06848 28.1876 5.06693C34.1343 4.63443 39.7483 6.32002 44.2863 9.48346L42.9918 10.778C38.8276 7.9596 33.7229 6.46911 28.3182 6.86219Z"
      fill="#94A6B8"
    />
  </svg>
);

export default styled(NonPalletizedModalIcon)``;
